/** Get Dashboard Chart data */
export const API_SUCCESS = "API_SUCCESS"
export const API_FAIL = "API_FAIL"
export const GET_CHARTS_DATA = "GET_CHARTS_DATA"

/* Get Dashboard Count data */
export const GET_DASHBOARD_DATA = "GET_DASHBOARD_DATA"
export const GET_DASHBOARD_DATA_SUCCESS = "GET_DASHBOARD_DATA_SUCCESS"
export const GET_DASHBOARD_DATA_FAIL = "GET_DASHBOARD_DATA_FAIL"

// promoter dashboard profile

export const GET_PROMOTER_PROFILE_DETAILS = "GET_PROMOTER_PROFILE_DETAILS"
export const GET_PROMOTER_PROFILE_DETAILS_SUCCESS =
  "GET_PROMOTER_PROFILE_DETAILS_SUCCESS"
export const GET_PROMOTER_PROFILE_DETAILS_FAIL =
  "GET_PROMOTER_PROFILE_DETAILS_FAIL"

// Promoter dashbord data

export const GET_PROMOTER_DASHBOARD_DATA = "GET_PROMOTER_DASHBOARD_DATA"
export const GET_PROMOTER_DASHBOARD_DATA_SUCCESS =
  "GET_PROMOTER_DASHBOARD_DATA_SUCCESS"
export const GET_PROMOTER_DASHBOARD_DATA_FAIL =
  "GET_PROMOTER_DASHBOARD_DATA_FAIL"

export const GET_DASHBOARD_LEAD_CHART_DATA = "GET_DASHBOARD_LEAD_CHART_DATA"
export const GET_DASHBOARD_LEAD_CHART_DATA_SUCCESS =
  "GET_DASHBOARD_LEAD_CHART_DATA_SUCCESS"
export const GET_DASHBOARD_LEAD_CHART_DATA_FAIL =
  "GET_DASHBOARD_LEAD_CHART_DATA_FAIL"

export const GET_DASHBOARD_VEHICLE_CHART_DATA =
  "GET_DASHBOARD_VEHICLE_CHART_DATA"
export const GET_DASHBOARD_VEHICLE_CHART_DATA_SUCCESS =
  "GET_DASHBOARD_VEHICLE_CHART_DATA_SUCCESS"
export const GET_DASHBOARD_VEHICLE_CHART_DATA_FAIL =
  "GET_DASHBOARD_VEHICLE_CHART_DATA_FAIL"

export const GET_DASHBOARD_SALE_CHART_DATA = "GET_DASHBOARD_SALE_CHART_DATA"
export const GET_DASHBOARD_SALE_CHART_DATA_SUCCESS =
  "GET_DASHBOARD_SALE_CHART_DATA_SUCCESS"
export const GET_DASHBOARD_SALE_CHART_DATA_FAIL =
  "GET_DASHBOARD_SALE_CHART_DATA_FAIL"



// Lead to Sale Ratio
export const GET_LEAD_TO_SALE_RATIO = "GET_LEAD_TO_SALE_RATIO"
export const GET_LEAD_TO_SALE_RATIO_SUCCESS = "GET_LEAD_TO_SALE_RATIO_SUCCESS"
export const GET_LEAD_TO_SALE_RATIO_FAIL = "GET_LEAD_TO_SALE_RATIO_FAIL"

export const GET_SALES_REPORT_DATA = "GET_SALES_REPORT_DATA"
export const GET_SALES_REPORT_DATA_SUCCESS = "GET_SALES_REPORT_DATA_SUCCESS"
export const GET_SALES_REPORT_DATA_FAIL = "GET_SALES_REPORT_DATA_FAIL"

export const GET_PURCHASE_REPORT_DATA = "GET_PURCHASE_REPORT_DATA"
export const GET_PURCHASE_REPORT_DATA_SUCCESS = "GET_PURCHASE_REPORT_DATA_SUCCESS"
export const GET_PURCHASE_REPORT_DATA_FAIL = "GET_PURCHASE_REPORT_DATA_FAIL"
